import { Box, CircularProgress, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { Navigate } from 'react-router-dom';

import { getProjectsBasePath } from '@verantos-dev/core-constants';

import { useAnalyticalDatasetProfileQuery } from '../api/useAnalyticalDatasetProfileQuery';
import { useAdRouteParams } from '../hooks/useAdRouteParams';
import { getAnalyticalDatasetVersionPath } from '../routes';

// Resolves the unversioned URL to the versioned one the detail page expects.
// Hit by typed URLs / external deep links; list-page navigations already
// carry the latest version id and bypass this resolver.
export const AnalyticalDatasetVersionResolverPage = () => {
  const { formatMessage } = useIntl();
  const { projectId, analyticalDatasetProfileId } = useAdRouteParams();

  const { data, error, isLoading } = useAnalyticalDatasetProfileQuery({
    projectId,
    analyticalDatasetProfileId,
  });

  const latestVersionId = data?.data.latestAnalyticalDatasetVersionId;

  if (latestVersionId) {
    return (
      <Navigate
        replace
        to={getAnalyticalDatasetVersionPath(projectId, analyticalDatasetProfileId, latestVersionId)}
      />
    );
  }

  if (error && !isLoading) {
    return (
      <Box
        data-testid="ad-version-resolver-error"
        sx={{ padding: 3, display: 'flex', flexDirection: 'column', gap: 1 }}
      >
        <Typography variant="subtitle1" color="error">
          {formatMessage({ id: 'analyticalDatasetDetail.versionResolver.errorTitle' })}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {formatMessage({ id: 'analyticalDatasetDetail.versionResolver.errorBody' })}{' '}
          <a href={getProjectsBasePath()}>
            {formatMessage({ id: 'analyticalDatasetDetail.versionResolver.backToProjects' })}
          </a>
          .
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      data-testid="ad-version-resolver-loading"
      sx={{ display: 'flex', justifyContent: 'center', paddingY: 6 }}
    >
      <CircularProgress size={24} />
    </Box>
  );
};
